import { CampusUnitsFaq } from './campus-units-faq.model';

export class CampusUnitsFaqSection {
    campusUnitsFaqSectionId: number;
    name: string;
    sectionOrder: number;
    updatedBy: string;
    updatedOn: Date;
    active: boolean;
    questions: CampusUnitsFaq[];
}
